import React from 'react'

import Download from '../../molecules/Download'

const DownloadList = ({ downloads }) => (
    <div>
        {downloads.map((item =><Download key={ item[0] } download={ item } />))}
    </div>
)

export default DownloadList



// WEBPACK FOOTER //
// ./src/components/organisms/DownloadList/DownloadList.js